export default "__VITE_ASSET__BYENudAG__"